import React, { useEffect } from 'react'

import { datadogRum } from '@datadog/browser-rum'
import {
  AlignItems,
  Box,
  Button,
  Display,
  FlexDirection,
  Heading3,
  Modal,
  ModalBody,
  ModalClose,
  ModalHeader,
  Text,
  useModal,
} from '@gousto-internal/citrus-react'

import { useCheckoutError } from 'routes/Menu/hooks/useCheckoutError'

export const CheckoutErrorModal = () => {
  const { closeCurrentModal } = useModal()
  const { actionLabel, errorCode, errorMessage, errorTitle, originalErrorMessage, retryFunc } =
    useCheckoutError()

  const handleClose = () => {
    closeCurrentModal()
    retryFunc?.()
  }

  useEffect(() => {
    if (errorCode) {
      datadogRum.addError(new Error('CheckoutErrorModal displayed: Uh oh, something went wrong'), {
        errorCode,
        originalErrorMessage,
      })
    }
  }, [errorCode, originalErrorMessage])

  return (
    <Modal isOpen={Boolean(errorCode)} name="checkout-error-modal">
      <ModalHeader>
        <Heading3>{errorTitle}</Heading3>
        <ModalClose onClose={handleClose} />
      </ModalHeader>
      <ModalBody>
        <Box
          alignItems={AlignItems.Center}
          display={Display.Flex}
          flexDirection={FlexDirection.Column}
          gap={4}
        >
          <Text>{errorMessage}</Text>
          <Button onClick={handleClose}>{actionLabel}</Button>
        </Box>
      </ModalBody>
    </Modal>
  )
}
